import gql from 'graphql-tag'

const mutations = {
  testConnection: gql`
    mutation TestConnection(
      $orchestratorId: ID
      $orchestratorUrl: String
      $orchestratorType: String
      $orchestratorPort: String
      $orchestratorUsername: String
      $orchestratorPassword: String
      $orchestratorServerKey: String
    ) {
      testConnection(
        orchestratorId: $orchestratorId
        orchestratorUrl: $orchestratorUrl
        orchestratorType: $orchestratorType
        orchestratorPort: $orchestratorPort
        orchestratorUsername: $orchestratorUsername
        orchestratorPassword: $orchestratorPassword
        orchestratorServerKey: $orchestratorServerKey
      ) {
        statusCode,
        body
      }
    }
  `,

  createTrialTeam: gql`
    mutation CreateTrialTeam(
      $email: String!
      $password: String!
      $region: String
      $teamName: String!
      $creatorName: String!
      $webOrigin: String!
    ) {
      createTrialTeam(
        email: $email
        password: $password
        region: $region
        teamName: $teamName
        creatorName: $creatorName
        webOrigin: $webOrigin
      ) {
        responseCode,
        statusText,
        authToken,
        orgId,
        name
      }
    }
  `,

  updateGlobalSettings: gql`
    mutation UpdateGlobalSettings(
      $minimumSupportedClientVersion: String!
      $permission: String!
      $winClientDownloadLink: String!
      $macosClientDownloadLink: String!
      $androidClientDownloadLink: String!
    ) {
      updateGlobalSettings(
        minimumSupportedClientVersion: $minimumSupportedClientVersion
        permission: $permission
        winClientDownloadLink: $winClientDownloadLink
        macosClientDownloadLink: $macosClientDownloadLink
        androidClientDownloadLink: $androidClientDownloadLink
      ) {
        minimumSupportedClientVersion
        winClientDownloadLink
        macosClientDownloadLink
        androidClientDownloadLink
      }
    }
  `,

  createOrchestrator: gql`
    mutation CreateOrchestrator(
      $name: String!
      $url: String!
      $managementPort: Int!
      $startPort: Int
      $endPort: Int
      $username: String!
      $password: String!
      $permission: String!
      $type: String!
    ) {
      createOrchestrator(
        name: $name
        url: $url
        managementPort: $managementPort
        startPort: $startPort
        endPort: $endPort
        username: $username
        password: $password
        permission: $permission
        type: $type
      ) {
        name,
        orchestratorId
      }
    }
  `,

  updateOrchestrator: gql`
    mutation UpdateOrchestrator(
      $orchestratorId: ID!
      $name: String!
      $url: String!
      $managementPort: Int!
      $startPort: Int
      $endPort: Int
      $username: String!
      $password: String!
      $permission: String!
      $type: String!
    ) {
      updateOrchestrator(
        orchestratorId: $orchestratorId
        name: $name
        url: $url
        managementPort: $managementPort
        startPort: $startPort
        endPort: $endPort
        username: $username
        password: $password
        permission: $permission
        type: $type
      ) {
        orchestratorId
        name
      }
    }
  `,

  removeOrchestrator: gql`
    mutation RemoveOrchestrator(
      $orchestratorId: ID!
      $userId: String!
      $accessTeamId: ID!
    ) {
      removeOrchestrator(
        orchestratorId: $orchestratorId
        userId: $userId
        accessTeamId: $accessTeamId
      ) {
        orchestratorId
      }
    }
  `,

  createCluster: gql`
    mutation createCluster(
      $name: String!
      $permission: String!
    ) {
      createCluster(
        name: $name
        permission: $permission
      ) {
        name,
        clusterId
      }
    }
  `,

  updateCluster: gql`
    mutation UpdateCluster(
      $clusterId: ID!
      $name: String!
      $permission: String!
    ) {
      updateCluster(
        clusterId: $clusterId
        name: $name
        permission: $permission
      ) {
        clusterId
        name
      }
    }
  `,

  removeCluster: gql`
    mutation RemoveCluster(
      $clusterId: ID!
      $userId: String!
      $accessTeamId: ID!
    ) {
      removeCluster(
        clusterId: $clusterId
        userId: $userId
        accessTeamId: $accessTeamId
      ) {
        clusterId
      }
    }
  `,

  orchestratorAttachTeam: gql`
    mutation OrchestratorAttachTeam(
      $orchestratorId: ID!
      $userId: String!
      $teamId: ID!
      $name: String!
    ) {
      orchestratorAttachTeam(
        orchestratorId: $orchestratorId
        userId: $userId
        teamId: $teamId
        name: $name
      ) {
        orchestratorId
      }
    }
  `,

  createAsset: gql`
    mutation CreateAsset(
      $name: String!
      $thumbnailUrl: String
      $permission: String!
    ) {
      createAsset(
        name: $name
        thumbnailUrl: $thumbnailUrl
        permission: $permission
      ) {
        name,
        assetId
      }
    }
  `,

  assetAttachTeam: gql`
    mutation AssetAttachTeam(
      $teamId: ID!
      $userId: String!
      $assetId: ID!
      $assetName: String!
    ) {
      assetAttachTeam(
        teamId: $teamId
        userId: $userId
        assetId: $assetId
        assetName: $assetName
      ) {
        assetId
        name
      }
    }
  `,

  assetDetachTeam: gql`
    mutation AssetDetachTeam(
      $teamId: ID!
      $userId: String!
      $assetId: ID!
      $assetName: String!
    ) {
      assetDetachTeam(
        teamId: $teamId
        userId: $userId
        assetId: $assetId
        assetName: $assetName
      ) {
        assetId
        name
      }
    }
  `,

  updateAsset: gql`
    mutation UpdateAsset(
      $assetId: ID!
      $name: String!
      $thumbnailUrl: String
      $permission: String!
    ) {
      updateAsset(
        assetId: $assetId
        name: $name
        thumbnailUrl: $thumbnailUrl
        permission: $permission
      ) {
        assetId
        name
      }
    }
  `,

  attachOrchestratorToCluster: gql`
    mutation AttachOrchestratorToCluster(
      $teamId: ID!
      $orchestratorId: ID!
      $userId: String!
      $clusterId: ID!
      $clusterName: String!
    ) {
      attachOrchestratorToCluster(
        teamId: $teamId
        orchestratorId: $orchestratorId
        userId: $userId
        clusterId: $clusterId
        clusterName: $clusterName
      ) {
        orchestratorId
        name
      }
    }
    `,

  detachOrchestratorFromCluster: gql`
    mutation DetachOrchestratorFromCluster(
      $teamId: ID!
      $orchestratorId: ID!
      $userId: String!
      $clusterId: ID!
      $clusterName: String!
    ) {
      detachOrchestratorFromCluster(
        teamId: $teamId
        orchestratorId: $orchestratorId
        userId: $userId
        clusterId: $clusterId
        clusterName: $clusterName
      ) {
        orchestratorId
        name
      }
    }
    `,

  attachTeamToCluster: gql`
    mutation AttachTeamToCluster(
      $userTeamId: ID!
      $attachTeamId: ID!
      $userId: String!
      $clusterId: ID!
      $clusterName: String!
    ) {
      attachTeamToCluster(
        userTeamId: $userTeamId
        attachTeamId: $attachTeamId
        userId: $userId
        clusterId: $clusterId
        clusterName: $clusterName
      ) {
        teamId
        name
      }
    }
    `,

  detachTeamFromCluster: gql`
    mutation DetachTeamFromCluster(
      $userTeamId: ID!
      $detachTeamId: ID!
      $userId: String!
      $clusterId: ID!
      $clusterName: String!
    ) {
      detachTeamFromCluster(
        userTeamId: $userTeamId
        detachTeamId: $detachTeamId
        userId: $userId
        clusterId: $clusterId
        clusterName: $clusterName
      ) {
        teamId
        name
      }
    }
    `,

  removeAsset: gql`
    mutation RemoveAsset(
      $assetId: ID!
      $accessTeamId: ID!
      $userId: String!
    ) {
      removeAsset(
        assetId: $assetId
        accessTeamId: $accessTeamId
        userId: $userId
      ) {
        assetId
      }
    }
  `,

  createInventoryItem: gql`
    mutation CreateInventoryItem(
      $name: String!
      $itemUrl: String!
      $itemType: String!
      $teamId: ID
      $sceneId: ID
      $fileSize: Int
      $thumbnailUrl: String
      $permission: String
      $imageWidth: Int
      $imageHeight: Int
    ) {
      createInventoryItem(
        name: $name,
        itemUrl: $itemUrl
        itemType: $itemType
        teamId: $teamId
        sceneId: $sceneId
        fileSize: $fileSize
        thumbnailUrl: $thumbnailUrl
        permission: $permission
        imageWidth: $imageWidth
        imageHeight: $imageHeight
      ) {
        inventoryItemId
      }
    }
  `,

  updateInventoryItem: gql`
    mutation UpdateInventoryItem(
      $inventoryItemId: ID!
      $name: String!
      $itemUrl: String!
      $itemType: String!
      $teamId: ID
      $sceneId: ID
      $fileSize: Int
      $thumbnailUrl: String
      $permission: String
    ) {
      updateInventoryItem(
        inventoryItemId: $inventoryItemId
        name: $name
        itemUrl: $itemUrl
        itemType: $itemType
        teamId: $teamId
        sceneId: $sceneId
        fileSize: $fileSize
        thumbnailUrl: $thumbnailUrl
        permission: $permission
      ) {
        inventoryItemId,
        updatedDate
      }
    }
  `,

  removeInventoryItem: gql`
    mutation RemoveInventoryItem(
      $inventoryItemId: ID!
      $teamId: ID!
      $email: String
    ) {
      removeInventoryItem(
        inventoryItemId: $inventoryItemId
        teamId: $teamId
        email: $email
      ) {
        inventoryItemId
      }
    }
  `,

  attachInventoryItem: gql`
    mutation AttachInventoryItem(
      $inventoryItemId: ID!
      $sceneId: ID!
      $email: String!
    ) {
      attachInventoryItem(
        inventoryItemId: $inventoryItemId
        sceneId: $sceneId
        email: $email
      ) {
        inventoryItemId
      }
    }
  `,

  createServerComponent: gql`
    mutation CreateServerComponent(
      $assetId: ID!,
      $teamId: ID!,
      $name: String!
      $imageUrl: String!
      $imageType: String!
      $startupArgs: String
      $downloadUsername: String
      $downloadPassword: String
      $imageTag: String
    ) {
      createServerComponent(
        assetId: $assetId,
        teamId: $teamId,
        name: $name
        imageUrl: $imageUrl
        imageType: $imageType
        startupArgs: $startupArgs
        downloadUsername: $downloadUsername
        downloadPassword: $downloadPassword
        imageTag: $imageTag
      ) {
        name,
        componentId
      }
    }
  `,

  updateServerComponent: gql`
    mutation UpdateServerComponent(
      $componentId: ID!,
      $name: String!
      $imageUrl: String!
      $imageType: String!
      $startupArgs: String
      $downloadUsername: String
      $downloadPassword: String
      $imageTag: String
    ) {
      updateServerComponent(
        assetId: $assetId,
        name: $name
        imageUrl: $imageUrl
        imageType: $imageType
        startupArgs: $startupArgs
        downloadUsername: $downloadUsername
        downloadPassword: $downloadPassword
        imageTag: $imageTag
      ) {
        componentId
        name
      }
    }
  `,

  removeServerComponent: gql`
  mutation RemoveServerComponent(
    $componentId: ID!
    $assetId: ID!
    $teamId: ID!
  ) {
    removeServerComponent(
      componentId: $componentId
      assetId: $assetId
      teamId: $teamId
    ) {
      componentId
    }
  }
`,

  createTeam: gql`
    mutation CreateTeam(
      $name: String!
      $defaultClusterId: ID!
      $streamingServerUrl: String
    ) {
      createTeam(
        name: $name
        defaultClusterId: $defaultClusterId
        streamingServerUrl: $streamingServerUrl
      ) {
        name,
        teamId,
        streamingServerUrl
      }
    }
  `,

  deleteTeam: gql`
    mutation DeleteTeam(
      $teamId: ID!
      $userEmail: String!
    ) {
      deleteTeam(
        teamId: $teamId
        userEmail: $userEmail
      ) {
        teamId
      }
    }
  `,

  userLeaveTeam: gql`
    mutation UserLeaveTeam(
      $teamId: ID!
      $memberId: String!
      $userId: String!
    ) {
      userLeaveTeam(
        teamId: $teamId
        memberId: $memberId
        userId: $userId
      ) {
        teamId
      }
    }
  `,

  userJoinTeam: gql`
    mutation UserJoinTeam(
      $teamId: ID!
      $memberId: String!
      $userId: String!
      $role: String!
      $nickname: String
      $avatar: String
      $name: String
      $invitationMessage: String
      $isUpdate: Boolean
      $resendInvitation: Boolean
      $createMemberWithoutInvitation: Boolean
    ) {
      userJoinTeam(
        teamId: $teamId
        memberId: $memberId
        userId: $userId
        role: $role
        nickname: $nickname
        avatar: $avatar
        name: $name
        invitationMessage: $invitationMessage
        isUpdate: $isUpdate
        resendInvitation: $resendInvitation
        createMemberWithoutInvitation: $createMemberWithoutInvitation
      ) {
        teamId
      }
    }
  `,

  createRoom: gql`
    mutation CreateRoom(
      $name: String!
      $teamId: ID!
      $serverKey: String
      $ip: String
      $port: Int
      $sceneName: String
      $sceneUrl: String
      $serviceUrl: String
      $orchestratorPort: Int
      $orchestratorUsername: String
      $orchestratorPassword: String
      $maxAllowedServicePort: Int
      $orchestratorId: ID
      $assetId: ID
      $assetName: String
      $orchestratorName: String
    ) {
      createRoom(
        name: $name
        teamId: $teamId
        serverKey: $serverKey
        ip: $ip
        port: $port
        sceneName: $sceneName
        sceneUrl: $sceneUrl
        serviceUrl: $serviceUrl
        orchestratorPort: $orchestratorPort
        orchestratorUsername: $orchestratorUsername
        orchestratorPassword: $orchestratorPassword
        maxAllowedServicePort: $maxAllowedServicePort
        orchestratorId: $orchestratorId
        assetId: $assetId
        assetName: $assetName
        orchestratorName: $orchestratorName
      ) {
        name,
        roomId
      }
    }
  `,

  updateTeam: gql`
    mutation UpdateTeam(
      $teamId: ID!
      $name: String!
      $orchestratorUrl: String
      $orchestratorPort: String
      $sessionPortRangeStart: Int
      $sessionPortRangeEnd: Int
      $orchestratorUsername: String
      $orchestratorPassword: String
      $defaultClusterId: ID
      $streamingServerUrl: String
      $teamTier: Int
    ) {
      updateTeam(
        teamId: $teamId,
        name: $name,
        orchestratorUrl: $orchestratorUrl,
        orchestratorPort: $orchestratorPort,
        sessionPortRangeStart: $sessionPortRangeStart,
        sessionPortRangeEnd: $sessionPortRangeEnd,
        orchestratorUsername: $orchestratorUsername,
        orchestratorPassword: $orchestratorPassword,
        defaultClusterId: $defaultClusterId,
        streamingServerUrl: $streamingServerUrl,
        teamTier: $teamTier
      ) {
        teamId
        name
      }
    }
  `,
  addTeamMember: gql`
    mutation AddTeamMember(
      $teamId: ID!,
      $email: String!,
      $role: String!
    ) {
    addTeamMember(
      teamId: $teamId,
      email: $email,
      role: $role
    ) {
      userId
      memberRole
      name
      email
    }
  }
  `,

  removeTeamMember: gql`
  mutation RemoveTeamMember(
    $teamId: ID!,
    $email: String!
  ) {
  removeTeamMember(
    teamId: $teamId,
    email: $email
  ) {
    userId
    memberRole
    name
    email
  }
}
`,

  updateRoom: gql`
    mutation UpdateRoom(
      $roomId: ID!,
      $name: String!,
      $ip: String,
      $port: Int,
      $sceneName: String,
      $sceneUrl: String,
      $invitees: String,
      $updateOperationType: Int,
      $teamId: ID,
      $orchestratorUsername: String,
      $orchestratorPassword: String,
      $thumbnailUrl: String,
      $streamingServerUrl: String
    ) {
      updateRoom(
        roomId: $roomId,
        name: $name,
        ip: $ip,
        port: $port,
        sceneName: $sceneName,
        sceneUrl: $sceneUrl,
        invitees: $invitees,
        updateOperationType: $updateOperationType,
        teamId: $teamId,
        orchestratorUsername: $orchestratorUsername,
        orchestratorPassword: $orchestratorPassword,
        thumbnailUrl: $thumbnailUrl,
        streamingServerUrl: $streamingServerUrl
      ) {
        roomId
        name
        ip
        port
        sceneName
        sceneUrl
        invitees
      }
    }
  `,

  createMeeting: gql`
    mutation CreateMeeting(
      $title: String!,
      $description: String, 
      $startDate: String, 
      $endDate: String, 
      $endTimeSpecified: Boolean!
    ) {
      createMeeting(
        title: $title, 
        description: $description, 
        startDate: $startDate, 
        endDate: $endDate, 
        endTimeSpecified: $endTimeSpecified
      ) {
        meetingId
        title
        description
        startDate
        endDate
        endTimeSpecified
      }
    }
  `,

  updateMeeting: gql`
    mutation UpdateMeeting(
      $meetingId: ID!,
      $title: String!,
      $description: String, 
      $startDate: String, 
      $endDate: String, 
      $endTimeSpecified: Boolean!
    ) {
      updateMeeting(
        meetingId: $meetingId,
        title: $title, 
        description: $description, 
        startDate: $startDate, 
        endDate: $endDate, 
        endTimeSpecified: $endTimeSpecified
      ) {
        meetingId
        title
        description
        startDate
        endDate
        endTimeSpecified
      }
    }
  `,

  deleteMeeting: gql`
    mutation DeleteMeeting(
      $meetingId: ID!
    ) {
      deleteMeeting(
        meetingId: $meetingId
      ) {
        meetingId
      }
    }
  `,

  leaveMeeting: gql`
    mutation LeaveMeeting($meetingId: ID!) {
      leaveMeeting(meetingId: $meetingId) {
        meetingId
      }
    }
  `,

  insertUserSettings: gql`
    mutation InsertUserSettings($userId: ID!) {
      insertUserSettings(userId: $userId) {
        userId
      }
    }
  `,

  updateUserSettings: gql`
    mutation UpdateUserSettings(
        $nickname: String, 
        $avatar: String
      ) {
      updateUserSettings(
        nickname: $nickname, 
        avatar: $avatar
      ) {
        nickname
        username
        email
        avatar
      }
    }
  `,

  confirmCodeLogin: gql`
    mutation ConfirmCodeLogin(
        $deviceCode: String
      ) {
      confirmCodeLogin(
        deviceCode: $deviceCode
      )
    }
  `
}

export default mutations
